(() => {
  // =========================
  // CONFIG
  // =========================
  const LS_UBIGEO = 'cart_ubigeo_v2';
  const LS_DELIVERY = 'cart_delivery_type_v1'; // 'shipping' | 'pickup'

  const cache = new Map();

  // =========================
  // DEBUG
  // =========================
  const DEBUG_UBIGEO = true;
  function dbgU(...args) {
    if (!DEBUG_UBIGEO) return;
    try { console.log('%c[UBIGEO]', 'color:#0a84ff;font-weight:700', ...args); } catch (e) { }
  }


  // ✅ Evita mezclar caches viejos cuando cambian los JSON (IDs cambian entre versiones/tiendas)
  (function cleanupOldUbigeoCache() {
    try {
      ['ubigeo_deptos_v1', 'ubigeo_provs_v1', 'ubigeo_dists_v2'].forEach((k) => {
        // antiguos keys (sin URL) -> los borramos una vez para no reutilizar data desactualizada
        if (localStorage.getItem(k)) localStorage.removeItem(k);
      });
    } catch (e) { }
  })();


  async function fetchJsonCached(url, storageKeyBase) {
    const storageKey = storageKeyBase ? `${storageKeyBase}:${url}` : null;

    if (cache.has(url)) return cache.get(url);

    if (storageKey) {
      try {
        const raw = localStorage.getItem(storageKey);
        if (raw) {
          const parsed = JSON.parse(raw);
          cache.set(url, parsed);
          return parsed;
        }
      } catch (e) { }
    }

    const res = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
    if (!res.ok) throw new Error(`No se pudo cargar ${url} (${res.status})`);
    const data = await res.json();

    cache.set(url, data);
    if (storageKey) {
      try { localStorage.setItem(storageKey, JSON.stringify(data)); } catch (e) { }
    }
    return data;
  }

  function sortByNombre(a, b) {
    return (a?.nombre_ubigeo || '').localeCompare(b?.nombre_ubigeo || '', 'es');
  }

  function norm(s) {
    return (s || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function resetSelect(selectEl, placeholder) {
    selectEl.innerHTML = '';
    const opt = document.createElement('option');
    opt.value = '';
    opt.textContent = placeholder;
    selectEl.appendChild(opt);
  }

  function fillSelect(selectEl, items) {
    const frag = document.createDocumentFragment();
    items.forEach((it) => {
      const opt = document.createElement('option');
      opt.value = String(it.id_ubigeo);
      opt.textContent = it.nombre_ubigeo;
      frag.appendChild(opt);
    });
    selectEl.appendChild(frag);
  }

  // ✅ Soporta distintas estructuras en distritos.json según la tienda/tema
  // - Caso A: { [provId]: [ {id_ubigeo, nombre_ubigeo, ...}, ... ] }
  // - Caso B: { [deptoId]: { [provId]: [ ... ] } }
  // - Caso C: { distritos: <A|B> } o { data: <A|B> }
  // - Caso D: [ { ..., provincia_id: <provId> }, ... ]
  function getDistrictsForProv(distritosData, deptoIdBase, provId) {
    const pKey = String(provId || '').trim();
    const dKey = String(deptoIdBase || '').trim();
    if (!pKey) return [];
    if (!distritosData) return [];

    // Objeto (map)
    if (!Array.isArray(distritosData) && typeof distritosData === 'object') {
      // A) map directo por provId
      if (Array.isArray(distritosData[pKey])) return distritosData[pKey];

      // B) anidado por deptoId -> provId
      const inner = distritosData[dKey];
      if (inner && typeof inner === 'object' && Array.isArray(inner[pKey])) return inner[pKey];

      // C) nesting común
      const nested = distritosData.distritos || distritosData.data || distritosData.items;
      if (nested && nested !== distritosData) return getDistrictsForProv(nested, deptoIdBase, provId);
    }

    // Array (lista plana con campo de provincia)
    if (Array.isArray(distritosData)) {
      const fields = [
        'provincia_id',
        'prov_id',
        'id_provincia',
        'ubigeo_prov_id',
        'id_ubigeo_provincia',
        'provincia'
      ];
      return distritosData.filter((d) => {
        if (!d || typeof d !== 'object') return false;
        for (const f of fields) {
          if (d[f] != null && String(d[f]) === pKey) return true;
        }
        return false;
      });
    }

    return [];
  }

  function setHiddenValues({ deptoName, provName, distName }) {
    const zone = document.getElementById('checkout-zone');      // Departamento (texto)
    const city = document.getElementById('checkout-city');      // Provincia (texto)
    const dist = document.getElementById('checkout-district');  // Distrito (texto)

    if (zone) zone.value = deptoName || '';
    if (city) city.value = provName || '';
    if (dist) dist.value = distName || '';
  }

  function saveUbigeo(payload) {
    try { localStorage.setItem(LS_UBIGEO, JSON.stringify(payload)); } catch (e) { }
    const status = document.getElementById('ubigeo-status');
    if (status) status.hidden = false;
  }

  function loadUbigeo() {
    try {
      const raw = localStorage.getItem(LS_UBIGEO);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }

  }

  // ✅ Persistir atributos en el carrito (para que /cart.js muestre attributes y llegue a la orden)
  async function persistCartAttributes(attributes) {
    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store',
        body: JSON.stringify({ attributes })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw data;
      return data;
    } catch (e) {
      console.warn('[UBIGEO persistCartAttributes]', e);
      return null;
    }
  }

  // ✅ Exponer para otros módulos (ej: submit/checkout)
  window.CartUbigeo = window.CartUbigeo || {};
  window.CartUbigeo.loadUbigeo = loadUbigeo;
  window.CartUbigeo.saveUbigeo = saveUbigeo;

  // ✅ Compatibilidad: algunos módulos llaman loadUbigeo() directo
  window.loadUbigeo = loadUbigeo;


  function getDeliveryType() {
    try { return localStorage.getItem(LS_DELIVERY); } catch (e) { return null; }
  }
  function setDeliveryType(type) {
    try { localStorage.setItem(LS_DELIVERY, type); } catch (e) { }
  }
  function clearDeliveryType() {
    try { localStorage.removeItem(LS_DELIVERY); } catch (e) { }
  }

  // =========================
  // PICKUP ETA (horario recojo)
  // Reglas (alineadas con los correos):
  // - Día hábil (Lun–Vie, no feriado)
  //   * 00:00–08:59 => mismo día desde 15:00
  //   * 09:00–23:59 => siguiente día hábil desde 12:00
  // - Sáb/Dom o feriado => siguiente día hábil desde 12:00
  // =========================
  function isWeekend(d) {
    const wd = d.getDay(); // 0 dom, 6 sáb
    return wd === 0 || wd === 6;
  }

  function pickupYmdKey(d) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  function getPickupHolidaySet() {
    try {
      const root = document.getElementById('CartUbigeo');
      const raw = (root?.dataset?.holidays || '').trim();
      if (!raw) return new Set();
      return new Set(
        raw.split(',')
          .map((s) => s.trim())
          .filter(Boolean)
      );
    } catch (e) {
      return new Set();
    }
  }

  function isPickupHoliday(d) {
    return getPickupHolidaySet().has(pickupYmdKey(d));
  }

  function isPickupBusinessDay(d) {
    return !isWeekend(d) && !isPickupHoliday(d);
  }

  function nextOpenDay(d) {
    const x = new Date(d);
    x.setDate(x.getDate() + 1);
    while (!isPickupBusinessDay(x)) x.setDate(x.getDate() + 1);
    return x;
  }

  function nextPickupReadyDate(now = new Date()) {
    const d = new Date(now);
    const mins = d.getHours() * 60 + d.getMinutes();

    // Día hábil antes de las 9:00 a. m. => mismo día desde 3:00 p. m.
    if (isPickupBusinessDay(d) && mins < 9 * 60) {
      d.setHours(15, 0, 0, 0);
      return d;
    }

    // Desde las 9:00 a. m., o si es fin de semana/feriado => siguiente día hábil desde 12:00 p. m.
    const n = nextOpenDay(d);
    n.setHours(14, 30, 0, 0);
    return n;
  }

  function formatPickupMessage(dt) {
    const dateFmt = new Intl.DateTimeFormat('es-PE', {
      weekday: 'long',
      day: '2-digit',
      month: 'short',
    });
    const timeFmt = new Intl.DateTimeFormat('es-PE', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });

    let dayText = dateFmt.format(dt);
    dayText = dayText.charAt(0).toUpperCase() + dayText.slice(1);

    return `<strong>Fecha estimada de recojo:</strong> ${dayText} desde las ${timeFmt.format(dt)}`;
  }

  function updatePickupEta() {
    const el = document.querySelector('#CartPickup [data-pickup-eta]');
    if (!el) return;

    // si no está en modo pickup, lo ocultamos (el contenedor igual se oculta, pero mejor)
    try {
      const type = getDeliveryType();
      if (type !== 'pickup') {
        el.hidden = true;
        el.innerHTML = '';
        return;
      }
    } catch (e) { }

    const ready = nextPickupReadyDate(new Date());
    el.innerHTML = formatPickupMessage(ready);
    el.hidden = false;
  }

  // Exponer para re-renders
  window.CartUbigeo = window.CartUbigeo || {};
  window.CartUbigeo.refreshPickupEta = updatePickupEta;

  function isCartPage() {
    return window.location.pathname === '/cart' || window.location.pathname.startsWith('/cart');
  }

  async function initUbigeo() {
    const root = document.getElementById('CartUbigeo');
    if (!root) return;

    // ✅ Guard: si ya está inicializado y el select de depto ya tiene opciones, no re-bindeamos
    const __selDeptoGuard = root.querySelector('#ubigeo-depto');
    if (root.dataset.ubigeoReady === '1' && __selDeptoGuard && __selDeptoGuard.options && __selDeptoGuard.options.length > 1) {
      return;
    }
    const urlDeptos = root.dataset.departamentos;
    const urlProvs = root.dataset.provincias;
    const urlDists = root.dataset.distritos;

    const selDepto = document.getElementById('ubigeo-depto');
    const selProv = document.getElementById('ubigeo-prov');
    const selDist = document.getElementById('ubigeo-dist');
    if (!selDepto || !selProv || !selDist) return;


    // ✅ Cross-theme: asegurar que los elementos con form="cart" apunten al ID real del formulario del carrito
    // (en algunos temas el form es #cart-form, en otros #cart)
    try {
      const cartForm =
        document.getElementById('cart')
        || document.getElementById('cart-form')
        || document.querySelector('form[action="/cart"]')
        || document.querySelector('form[action$="/cart"]');

      if (cartForm && cartForm.id) {
        root.querySelectorAll('[form="cart"]').forEach((el) => el.setAttribute('form', cartForm.id));
      }
    } catch (e) { }

    // ✅ UI (resumen / editor)
    const calcBox = root.closest('.calcular-lugar') || root.parentElement;
    const panel = calcBox?.querySelector('.cart-ubigeo'); // contenedor que muestra selects
    const openBtn = calcBox?.querySelector('.open-calculo--lugar'); // botón "Calcular" (si existe)

    const summary = calcBox?.querySelector('#CartUbigeoSummary');
    const sumItems = summary?.querySelector('[data-ubigeo-items]');
    const sumDist = summary?.querySelector('[data-ubigeo-dist]');
    const sumProv = summary?.querySelector('[data-ubigeo-prov]');
    const changeBtn = summary?.querySelector('[data-ubigeo-change]');
// ✅ ETA (fechas estimadas) administrable desde bloques "ETA por departamento"
// ✅ ETA (fechas estimadas) POR DISTRITO desde JSON (lt_before/lt_after)
const etaEl = summary?.querySelector('[data-ubigeo-eta]');

// ✅ Feriados (config en el HTML: data-holidays="YYYY-MM-DD,..." en #CartUbigeo)
const HOLIDAYS_SET = (() => {
  try {
    const raw = (root?.dataset?.holidays || '').trim();
    if (!raw) return new Set();
    return new Set(
      raw.split(',')
        .map((s) => s.trim())
        .filter(Boolean)
    );
  } catch (e) {
    return new Set();
  }
})();

function ymdKey(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function isHoliday(d) {
  return HOLIDAYS_SET.has(ymdKey(d));
}

function addBusinessDays(fromDate, days) {
  const d = new Date(fromDate);
  let added = 0;
  while (added < days) {
    d.setDate(d.getDate() + 1);
    const wd = d.getDay(); // 0 dom, 6 sáb
    // ✅ Se salta domingo y feriados. El sábado sí cuenta.
    if (wd !== 0 && !isHoliday(d)) added++;
  }
  return d;
}

function formatEtaDate(d) {
  // ✅ Incluye día de la semana + fecha (ej: "Martes 07 mar")
  const fmt = new Intl.DateTimeFormat('es-PE', {
    weekday: 'long',
    day: '2-digit',
    month: 'short',
  });

  let out = fmt.format(d);
  out = out.charAt(0).toUpperCase() + out.slice(1);
  return out;
}

function getEtaContext() {
      const now = new Date();
      const day = now.getDay(); // 0 dom, 1 lun, 2 mar, 3 mie, 4 jue, 5 vie, 6 sab
      const minutes = now.getHours() * 60 + now.getMinutes();
      const isAfter12pm = minutes >= 12 * 60;

      const base = new Date(now);
      base.setHours(0, 0, 0, 0);

      // ✅ Viernes desde las 12pm:
      // día 0 = lunes (o siguiente día válido) y usa BEFORE
      if (day === 5 && isAfter12pm) {
        base.setDate(base.getDate() + 3); // viernes -> lunes

        while (base.getDay() === 0 || isHoliday(base)) {
          base.setDate(base.getDate() + 1);
          base.setHours(0, 0, 0, 0);
        }

        return {
          baseDate: base,
          useAfterWindow: false
        };
      }

      // ✅ Sábado o domingo:
      // día 0 = lunes (o siguiente día válido) y usa BEFORE
      if (day === 6 || day === 0) {
        while (base.getDay() === 0 || isHoliday(base)) {
          base.setDate(base.getDate() + 1);
          base.setHours(0, 0, 0, 0);
        }

        return {
          baseDate: base,
          useAfterWindow: false
        };
      }

      // ✅ Feriado entre semana:
      // el día 0 pasa al siguiente día válido.
      // Se respeta la ventana horaria real del momento.
      if (isHoliday(base)) {
        while (base.getDay() === 0 || isHoliday(base)) {
          base.setDate(base.getDate() + 1);
          base.setHours(0, 0, 0, 0);
        }

        return {
          baseDate: base,
          useAfterWindow: isAfter12pm
        };
      }

      // ✅ Lunes a jueves, y viernes antes de las 12pm:
      // día 0 = hoy; before/after depende de la hora
      return {
        baseDate: base,
        useAfterWindow: (day === 5 ? false : isAfter12pm)
      };
    }

    function getEtaBaseDate() {
      return getEtaContext().baseDate;
    }

    function getLeadRangeFromSaved(saved) {
      if (!saved) return null;

      const ctx = getEtaContext();
      const rawMin = ctx.useAfterWindow ? saved.lt_after_min : saved.lt_before_min;
      const rawMax = ctx.useAfterWindow ? saved.lt_after_max : saved.lt_before_max;

      // 👇 si viene null/undefined, NO inventamos 0
      if (rawMin == null || rawMax == null) return null;

      const min = Number(rawMin);
      const max = Number(rawMax);

      if (!Number.isFinite(min) || !Number.isFinite(max)) return null;

      const a = Math.max(0, min);
      const b = Math.max(a, max);
      return { min: a, max: b };
    }

    function renderEta(range) {
      if (!etaEl) return;

      const base = getEtaBaseDate();
      const start = addBusinessDays(base, range.min);
      const end = addBusinessDays(base, range.max);

      if (range.min === range.max) {
        etaEl.innerHTML = `<strong>Entrega prevista:</strong> ${formatEtaDate(start)}`;
      } else {
        etaEl.innerHTML = `<strong>Entrega prevista:</strong> Entre el ${formatEtaDate(start)} y el ${formatEtaDate(end)}`;
      }
      etaEl.hidden = false;
    }

    function updateEtaFromSaved() {
      if (!etaEl) return;
      const saved = loadUbigeo();
      const range = getLeadRangeFromSaved(saved);

      if (!range) {
        etaEl.hidden = true;
        etaEl.innerHTML = '';
        return;
      }
      renderEta(range);
    }

    // Exponer refresh ETA (por si haces re-render del carrito)
    window.CartUbigeo = window.CartUbigeo || {};
    window.CartUbigeo.refreshEta = updateEtaFromSaved;

    let itemCountCache = null;
    async function getItemCount() {
      if (itemCountCache !== null) return itemCountCache;
      try {
        const r = await fetch('/cart.js', {
          headers: { 'Accept': 'application/json' },
          cache: 'no-store',
          credentials: 'same-origin'
        });
        const cart = await r.json();
        itemCountCache = Number(cart?.item_count || 0);
      } catch (e) {
        itemCountCache = 0;
      }
      return itemCountCache;
    }

    function showEditor() {
      if (summary) summary.hidden = true;
      if (panel) panel.classList.add('is-open');
      if (openBtn) openBtn.hidden = true; // si tu botón "Calcular" debe ocultarse al abrir
    }

    // ✅ Exponer abrir editor (para que "Envío a domicilio" haga de "Calcular")
    window.CartUbigeo = window.CartUbigeo || {};
    window.CartUbigeo.openEditor = showEditor;

    async function showSummaryUI({ provName, distName }) {
      if (!summary) return;

      const count = await getItemCount();
      const itemsText = count === 1 ? '1 ítem' : `${count} ítems`;

      if (sumItems) sumItems.textContent = itemsText;
      if (sumDist) sumDist.textContent = distName || '';
      if (sumProv) sumProv.textContent = provName || '';

      if (panel) panel.classList.remove('is-open');
      summary.hidden = false;
      if (openBtn) openBtn.hidden = true;


      // ✅ ETA debajo de "Entregar ..."
      const deptoName = (loadUbigeo()?.deptoName) || (selDepto.options[selDepto.selectedIndex]?.textContent || '');
      updateEtaFromSaved();
    }

    // ✅ Permite refrescar "Entregar X ítems" cuando cambie el carrito (AJAX)
    async function refreshSummaryCount() {
      if (!summary || summary.hidden) return;

      // invalida cache y vuelve a consultar
      itemCountCache = null;

      const saved = loadUbigeo();
      const provName = saved?.provName || (sumProv?.textContent || '');
      const distName = saved?.distName || (sumDist?.textContent || '');

      await showSummaryUI({ provName, distName });
    }

    // expone un refresh global (para que lo llamemos al cambiar el carrito)
    window.CartUbigeo = window.CartUbigeo || {};
    window.CartUbigeo.refreshSummary = refreshSummaryCount;

    function resetToInitialUI() {
      // cuando aún no está completo
      if (summary) summary.hidden = true;
      if (openBtn) openBtn.hidden = false; // que se vea el botón "Calcular"
    }

    // Click "Calcular" -> abre editor
    openBtn?.addEventListener('click', () => showEditor());

    // Click "Cambiar" -> vuelve al editor
    changeBtn?.addEventListener('click', () => {
      itemCountCache = null; // por si cambió el carrito
      showEditor();
    });

    // Estado inicial selects
    resetSelect(selProv, 'Selecciona una provincia…');
    resetSelect(selDist, 'Selecciona un distrito…');
    selProv.disabled = true;
    selDist.disabled = true;

    // 1) Departamentos (con split Lima)
    const deptos = await fetchJsonCached(urlDeptos, 'ubigeo_deptos_v1');

    // ✅ Lima (Metropolitana) primero, y Callao como opción separada (virtual)
    const expanded = [];
    const hasCallaoAsDepto = deptos.some(d => norm(d.nombre_ubigeo) === 'callao');

    deptos.forEach(d => {
      const n = norm(d.nombre_ubigeo);

      if (n === 'lima') {
        // 1) Lima Metropolitana
        expanded.push({ ...d, id_ubigeo: `${d.id_ubigeo}|LMA`, nombre_ubigeo: 'Lima (Metropolitana)' });

        // 2) Callao (como "departamento" separado)
        if (!hasCallaoAsDepto) {
          expanded.push({ ...d, id_ubigeo: `${d.id_ubigeo}|CAL`, nombre_ubigeo: 'Callao' });
        }

        // 3) Lima Departamento (resto)
        expanded.push({ ...d, id_ubigeo: `${d.id_ubigeo}|LIM`, nombre_ubigeo: 'Lima (Departamento)' });
        return;
      }

      // Si tu JSON ya trajera Callao como departamento real, lo dejamos tal cual
      expanded.push(d);
    });

    const priorityDepto = (x) => {
      const n = norm(x.nombre_ubigeo);
      if (n === 'lima (metropolitana)') return 0;
      if (n === 'callao') return 1;
      return 10;
    };

    const deptosSorted = expanded.sort((a, b) => {
      const pa = priorityDepto(a);
      const pb = priorityDepto(b);
      if (pa !== pb) return pa - pb;
      return sortByNombre(a, b);
    });

    fillSelect(selDepto, deptosSorted);
    let currentDists = [];

    async function onDeptoChange(restoreProvId = null, restoreDistId = null) {
      const rawDeptoId = selDepto.value;

      resetSelect(selProv, 'Selecciona una provincia…');
      resetSelect(selDist, 'Selecciona un distrito…');
      selProv.disabled = true;
      selDist.disabled = true;

      resetToInitialUI();

      if (!rawDeptoId) {
        setHiddenValues({ deptoName: '', provName: '', distName: '' });
        return;
      }

      const parts = String(rawDeptoId).split('|');
      const deptoId = parts[0];
      const limaMode = parts[1] || null; // 'LMA' | 'CAL' | 'LIM' | null

      const provinciasMap = await fetchJsonCached(urlProvs, 'ubigeo_provs_v1');
      let provsAll = (provinciasMap[String(deptoId)] || []).slice();

      if (limaMode === 'LMA') {
        // ✅ Solo provincias de Lima (Metropolitana) SIN Callao
        provsAll = provsAll.filter(p => {
          const n = norm(p.nombre_ubigeo);
          return n === 'lima';
        });
      } else if (limaMode === 'CAL') {
        // ✅ Callao como "departamento" separado (virtual)
        provsAll = provsAll.filter(p => {
          const n = norm(p.nombre_ubigeo);
          return n === 'callao';
        });
      } else if (limaMode === 'LIM') {
        // ✅ Resto del departamento de Lima (excluye Lima y Callao)
        provsAll = provsAll.filter(p => {
          const n = norm(p.nombre_ubigeo);
          return n !== 'lima' && n !== 'callao';
        });
      }

      const provs = provsAll.sort(sortByNombre);
      fillSelect(selProv, provs);
      selProv.disabled = false;

      if (restoreProvId) {
        selProv.value = String(restoreProvId);
        await onProvChange(restoreDistId);
      }
    }

    async function onProvChange(restoreDistId = null) {
      const provId = selProv.value;

      resetSelect(selDist, 'Selecciona un distrito…');
      selDist.disabled = true;

      resetToInitialUI();

      if (!provId) {
        const deptoName = selDepto.options[selDepto.selectedIndex]?.textContent || '';
        setHiddenValues({ deptoName, provName: '', distName: '' });
        return;
      }

      const distritosData = await fetchJsonCached(urlDists, 'ubigeo_dists_v2');

      // 👇 soporte cross-store: puede venir como map por provId, map anidado por depto->prov, o lista plana
      const deptoIdBase = String(selDepto.value || '').split('|')[0];
      const list = getDistrictsForProv(distritosData, deptoIdBase, provId);

      currentDists = (list || []).slice().sort(sortByNombre);

      // Si no hay distritos, lo dejamos bloqueado y dejamos un warning para que puedas detectar la causa.
      if (!currentDists.length) {
        const deptoName = selDepto.options[selDepto.selectedIndex]?.textContent || '';
        const provName = selProv.options[selProv.selectedIndex]?.textContent || '';
        setHiddenValues({ deptoName, provName, distName: '' });

        try {
          const sampleKeys = (!Array.isArray(distritosData) && distritosData && typeof distritosData === 'object')
            ? Object.keys(distritosData).slice(0, 20)
            : null;

          console.warn('[UBIGEO] No se encontraron distritos para la provincia seleccionada', {
            provId,
            deptoIdBase,
            urlDists,
            sampleKeys,
            note: 'Revisa la estructura de distritos.json (map por provId o por depto->prov).'
          });
        } catch (e) { }

        resetSelect(selDist, 'No hay distritos para esta provincia…');
        selDist.disabled = true;
        return;
      }

      fillSelect(selDist, currentDists);
      selDist.disabled = false;

      if (restoreDistId) {
        selDist.value = String(restoreDistId);
        onDistChange(true);
      } else {
        onDistChange(false);
      }
    }

    function onDistChange(isRestore = false) {
      const deptoName = selDepto.options[selDepto.selectedIndex]?.textContent || '';
      const provName = selProv.options[selProv.selectedIndex]?.textContent || '';
      const distName = selDist.options[selDist.selectedIndex]?.textContent || '';

      const distObj = currentDists.find(d => String(d.id_ubigeo) === String(selDist.value));

      const lt_before_min = Number(distObj?.lt_before_min);
      const lt_before_max = Number(distObj?.lt_before_max);
      const lt_after_min = Number(distObj?.lt_after_min);
      const lt_after_max = Number(distObj?.lt_after_max);

      setHiddenValues({ deptoName, provName, distName });

      if (selDepto.value && selProv.value && selDist.value) {
        saveUbigeo({
          deptoId: selDepto.value,
          provId: selProv.value,
          distId: selDist.value,
          deptoName, provName, distName,

          lt_before_min, lt_before_max,
          lt_after_min, lt_after_max
        });
        // ✅ Guardar también en cart.attributes (para que llegue al pedido y al correo)
        persistCartAttributes({
          "Tipo de entrega": "Despacho a domicilio",
          "Departamento": deptoName,
          "Provincia": provName,
          "Distrito": distName,
          "_lt_before_min": (Number.isFinite(lt_before_min) ? lt_before_min : ""),
          "_lt_before_max": (Number.isFinite(lt_before_max) ? lt_before_max : ""),
          "_lt_after_min": (Number.isFinite(lt_after_min) ? lt_after_min : ""),
          "_lt_after_max": (Number.isFinite(lt_after_max) ? lt_after_max : "")
        });

        // ✅ NUEVO: al completar distrito, ocultar selects y mostrar resumen
        showSummaryUI({ provName, distName });
        return;
      }

      if (!isRestore) {
        const status = document.getElementById('ubigeo-status');
        if (status) status.hidden = true;
      }

      resetToInitialUI();
    }

    selDepto.addEventListener('change', () => onDeptoChange());
    selProv.addEventListener('change', () => onProvChange());
    selDist.addEventListener('change', () => onDistChange());

    // Restaurar selección
    const saved = loadUbigeo();
    if (saved?.deptoId) {
      selDepto.value = String(saved.deptoId);
      await onDeptoChange(saved.provId, saved.distId);

      // ✅ Si ya estaba completo, muestra resumen al cargar
      if (saved.provId && saved.distId) {
        const provName = selProv.options[selProv.selectedIndex]?.textContent || saved.provName || '';
        const distName = selDist.options[selDist.selectedIndex]?.textContent || saved.distName || '';
        showSummaryUI({ provName, distName });
      }
    } else {
      // sin data previa: que se vea el botón "Calcular"
      resetToInitialUI();
    }

    // ✅ marcado como listo (para evitar doble bind en re-renders)
    root.dataset.ubigeoReady = '1';
  }


  function initDeliveryTypeUI() {
    const box = document.getElementById('CartDeliveryType');
    if (!box) return;

    if (box.dataset.bound === '1') return;

    const btnShip = box.querySelector('[data-delivery="shipping"]');
    const btnPick = box.querySelector('[data-delivery="pickup"]');

    const shippingUI = document.getElementById('CartShippingUI');
    const pickupUI = document.getElementById('CartPickup');

    function resetUI() {
      btnShip?.classList.remove('is-active');
      btnPick?.classList.remove('is-active');

      if (shippingUI) shippingUI.hidden = true;
      if (pickupUI) pickupUI.hidden = true;

      // ✅ oculta bloque de envío / total recalculado por si quedó algo
      try { window.CartShippingEstimate?.refresh?.(false); } catch (e) { }
    }

    function apply(type) {
      // type: 'shipping' | 'pickup'
      setDeliveryType(type);

      btnShip?.classList.toggle('is-active', type === 'shipping');
      btnPick?.classList.toggle('is-active', type === 'pickup');

      if (shippingUI) shippingUI.hidden = (type !== 'shipping');
      if (pickupUI) pickupUI.hidden = (type !== 'pickup');

      try { window.CartShippingEstimate?.refresh?.(false); } catch (e) { }
      try { window.CartUbigeo?.refreshPickupEta?.(); } catch (e) { }
    }

    btnShip?.addEventListener('click', () => {
      apply('shipping');

      requestAnimationFrame(() => {
        const summary = document.getElementById('CartUbigeoSummary');
        if (summary && summary.hidden) window.CartUbigeo?.openEditor?.();
      });
    });

    btnPick?.addEventListener('click', () => apply('pickup'));

    // ✅ Al cargar: si ya había selección guardada, respétala; si no, no selecciones nada
    const stored = getDeliveryType();
    const initial = (stored === 'shipping' || stored === 'pickup') ? stored : 'shipping';
    dbgU('initDeliveryTypeUI initial', { stored, initial });

    // ✅ aplicamos estado inicial (por defecto shipping)
    apply(initial);

    // Si es shipping y el resumen no está visible (o no hay selección), abrimos el editor
    if (initial === 'shipping') {
      requestAnimationFrame(() => {
        const summary = document.getElementById('CartUbigeoSummary');
        if (summary && summary.hidden) window.CartUbigeo?.openEditor?.();
      });
    }

    box.dataset.bound = '1';
  }

  function stripUbigeoRequired() {
    try {
      document.querySelectorAll('#CartUbigeo select.cart-ubigeo__select').forEach((s) => {
        s.removeAttribute('required');
      });
    } catch (e) { }
  }

  // ✅ ejecutar lo antes posible (por si alguna app valida el form antes de DOMContentLoaded)
  if (isCartPage()) stripUbigeoRequired();

  document.addEventListener('DOMContentLoaded', () => {
    if (!isCartPage()) return;

    // ✅ evitar validación HTML5 en selects ocultos
    stripUbigeoRequired();

    initDeliveryTypeUI();
    initUbigeo().catch((err) => console.error('[UBIGEO]', err));
  });

  // ✅ BFCache / back-forward cache
  window.addEventListener('pageshow', () => scheduleUbigeoReinit('pageshow'));
  // ✅ 1 re-init inicial extra (por si el theme pinta bloques tarde)
  scheduleUbigeoReinit('boot');

  // ✅ si el carrito se re-renderiza, vuelve a quitar required

  // ✅ Re-inicializa UI de delivery + ubigeo cuando el theme re-renderiza el carrito (ej: añadir producto, cambiar qty, cupón)
  // - Algunos themes NO emiten cart:rendered al agregar items; por eso añadimos MutationObserver como respaldo.
  var __ubigeoReinitTimer = null;
  var __ubigeoReinitRetry = null;

  function scheduleUbigeoReinit(reason = '') {
    if (!isCartPage()) return;
    clearTimeout(__ubigeoReinitTimer);
    clearTimeout(__ubigeoReinitRetry);

    __ubigeoReinitTimer = setTimeout(async () => {
      dbgU('scheduleUbigeoReinit', reason);

      // volver a quitar required (por si el theme reinyectó HTML)
      try { stripUbigeoRequired(); } catch (e) { }

      // re-binds de UI
      try { initDeliveryTypeUI(); } catch (e) { }

      // re-init ubigeo (rellena selects + restaura)
      try {
        await initUbigeo();
      } catch (e) {
        console.error('[UBIGEO] initUbigeo', e);
      }

      // re-init custom selects (si aplica)
      try { window.CartUbigeo?.initCustomSelects?.(); } catch (e) { }

      // re-calcular envío si ya hay selección
      try { window.CartShippingEstimate?.refresh?.(true); } catch (e) { }

      // ✅ Retry suave: si el carrito se acaba de re-renderizar, a veces el DOM aún no está completo
      __ubigeoReinitRetry = setTimeout(() => {
        try {
          const root = document.getElementById('CartUbigeo');
          const sel = root?.querySelector('#ubigeo-depto');
          if (root && sel && sel.options && sel.options.length <= 1) {
            // fuerza re-intento (sin romper caches)
            initUbigeo().then(() => {
              try { window.CartUbigeo?.initCustomSelects?.(); } catch (e) { }
              try { window.CartShippingEstimate?.refresh?.(true); } catch (e) { }
            }).catch((err) => console.error('[UBIGEO] retry', err));
          }
        } catch (e) { }
      }, 450);
    }, 180);
  }

  // ✅ Exponer re-init para otros módulos
  window.CartUbigeo = window.CartUbigeo || {};
  window.CartUbigeo.scheduleReinit = scheduleUbigeoReinit;

  // ✅ Hook global para detectar cambios del carrito aunque el theme no emita eventos
  (function hookUbigeoCartMutations() {
    if (window.__UBIGEO_CART_MUTATION_HOOKED__) return;
    window.__UBIGEO_CART_MUTATION_HOOKED__ = true;

    const isCartMutationUrl = (url = '') => {
      const u = String(url);
      return (
        /\/cart\/(add|change|update|clear)\.js(\?|$)/.test(u) ||
        (u.includes('sections=') && u.includes('/cart'))
      );
    };

    const debounce = (fn, wait = 250) => {
      let t = null;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...args), wait);
      };
    };

    const trigger = debounce((reason) => scheduleUbigeoReinit(reason), 220);

    // Hook FETCH
    try {
      const _fetch = window.fetch;
      if (_fetch && !window.__UBIGEO_FETCH_HOOKED__) {
        window.__UBIGEO_FETCH_HOOKED__ = true;
        window.fetch = async (...args) => {
          const res = await _fetch(...args);
          try {
            const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
            if (isCartMutationUrl(url)) setTimeout(() => trigger('fetch:' + url), 0);
          } catch (e) { }
          return res;
        };
      }
    } catch (e) { }

    // Hook XHR
    try {
      if (!window.__UBIGEO_XHR_HOOKED__) {
        window.__UBIGEO_XHR_HOOKED__ = true;

        const open = XMLHttpRequest.prototype.open;
        const send = XMLHttpRequest.prototype.send;

        XMLHttpRequest.prototype.open = function (method, url, ...rest) {
          this.__ubigeoUrl = url;
          return open.call(this, method, url, ...rest);
        };

        XMLHttpRequest.prototype.send = function (...args) {
          this.addEventListener('loadend', () => {
            try {
              if (isCartMutationUrl(this.__ubigeoUrl)) trigger('xhr:' + this.__ubigeoUrl);
            } catch (e) { }
          });
          return send.apply(this, args);
        };
      }
    } catch (e) { }

    // Fallback: MutationObserver (solo cambios reales del carrito; evita loops por UI interna)
    try {
      if (!window.__UBIGEO_MO_SMART__) {
        window.__UBIGEO_MO_SMART__ = true;

        const ITEMS_SEL = 'cart-items, #main-cart-items';
        const FOOTER_SEL = '#main-cart-footer';

        const isElement = (n) => n && n.nodeType === 1; // ELEMENT_NODE

        const nodeHas = (node, selector) => {
          if (!isElement(node)) return false;
          try {
            if (node.matches && node.matches(selector)) return true;
            return !!(node.querySelector && node.querySelector(selector));
          } catch (e) { return false; }
        };

        const isRelevant = (mutations) => {
          for (const m of mutations) {
            if (m.type !== 'childList') continue;

            // Si cambiaron nodos del listado de items o footer del carrito
            if (nodeHas(m.target, ITEMS_SEL) || nodeHas(m.target, FOOTER_SEL)) return true;

            const nodes = [];
            if (m.addedNodes && m.addedNodes.length) nodes.push(...m.addedNodes);
            if (m.removedNodes && m.removedNodes.length) nodes.push(...m.removedNodes);

            for (const n of nodes) {
              if (nodeHas(n, ITEMS_SEL) || nodeHas(n, FOOTER_SEL)) return true;
              // Cart items individuales (según tema)
              if (nodeHas(n, '.cart-item, cart-item, [data-cart-item]')) return true;
            }
          }
          return false;
        };

        const attach = (el, label, opts) => {
          if (!el || el.__ubigeoMoAttached) return;
          el.__ubigeoMoAttached = true;

          let last = 0;
          const mo = new MutationObserver((mutations) => {
            const now = Date.now();
            if (now - last < 500) return; // throttle fuerte
            if (!isRelevant(mutations)) return;
            last = now;
            trigger('mutation:' + label);
          });

          mo.observe(el, opts);
        };

        // 1) Observa SOLO cambios directos del listado de items (sin subtree => no se dispara por cambios internos)
        const itemsEl = document.querySelector('cart-items') || document.getElementById('main-cart-items');
        attach(itemsEl, 'items', { childList: true, subtree: false });

        // 2) Observa footer (sin subtree) por si el theme reemplaza el bloque de totales
        const footerEl = document.getElementById('main-cart-footer');
        attach(footerEl, 'footer', { childList: true, subtree: false });

        // 3) Observa el contenedor principal SOLO para detectar reemplazo completo de secciones (cart-items/footer)
        const mainEl = document.getElementById('MainContent') || document.body;
        attach(mainEl, 'main', { childList: true, subtree: true });
      }
    } catch (e) { }
  })();


  // Eventos custom (si el theme los emite)
  ['cart:rendered', 'cart:updated', 'cart:change'].forEach((evt) => {
    document.addEventListener(evt, () => scheduleUbigeoReinit(evt));
  });

  document.addEventListener('cart:rendered', () => {
    if (!isCartPage()) return;
    stripUbigeoRequired();
  });
})();


// =========================
// Submit -> Checkout redirect
// =========================
(() => {
  const form = document.getElementById('cart')
    || document.getElementById('cart-form')
    || document.querySelector('form[action="/cart"]')
    || document.querySelector('form[action$="/cart"]');
  if (!form) return;

  const LS_DELIVERY = 'cart_delivery_type_v1';

  const $dep = document.getElementById('ubigeo-depto');
  const $prov = document.getElementById('ubigeo-prov');
  const $dist = document.getElementById('ubigeo-dist');

  function normalize(s) { return (s || '').trim(); }
  function selectedText(sel) {
    return sel ? normalize(sel.options[sel.selectedIndex]?.textContent) : '';
  }

  // ✅ Departamento (texto) -> province_code Shopify
  const DEPT_CODE = {
    "Amazonas": "PE-AMA",
    "Áncash": "PE-ANC", "Ancash": "PE-ANC",
    "Apurímac": "PE-APU", "Apurimac": "PE-APU",
    "Arequipa": "PE-ARE",
    "Ayacucho": "PE-AYA",
    "Cajamarca": "PE-CAJ",
    "Cusco": "PE-CUS", "Cuzco": "PE-CUS",
    "Huancavelica": "PE-HUV",
    "Huánuco": "PE-HUC", "Huanuco": "PE-HUC",
    "Ica": "PE-ICA",
    "Junín": "PE-JUN", "Junin": "PE-JUN",
    "La Libertad": "PE-LAL",
    "Lambayeque": "PE-LAM",
    "Lima (Metropolitana)": "PE-LMA",
    "Lima (Departamento)": "PE-LIM",
    "Loreto": "PE-LOR",
    "Madre de Dios": "PE-MDD",
    "Moquegua": "PE-MOQ",
    "Pasco": "PE-PAS",
    "Piura": "PE-PIU",
    "Puno": "PE-PUN",
    "San Martín": "PE-SAM", "San Martin": "PE-SAM",
    "Tacna": "PE-TAC",
    "Tumbes": "PE-TUM",
    "Ucayali": "PE-UCA"
  };

  async function updateCart(payload) {
    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store',
        body: JSON.stringify(payload)
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw data;
      return data;
    } catch (e) {
      console.warn('[CART UPDATE]', e);
      return null;
    }
  }

  async function getCart() {
    const res = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    });
    return res.json();
  }

  function buildPermalink(cart, paramsObj) {
    const itemsPath = (cart.items || []).map(it => `${it.id}:${it.quantity}`).join(',');
    const url = new URL(itemsPath ? `/cart/${itemsPath}` : '/checkout', window.location.origin);

    // 1) Params checkout (shipping address, discount, etc.)
    Object.entries(paramsObj).forEach(([k, v]) => {
      if (v !== undefined && v !== null && String(v).trim() !== '') url.searchParams.set(k, String(v));
    });

    // 2) ✅ IMPORTANTE: si rediriges a /cart/{items}, Shopify "reconstruye" el carrito.
    // Para no perder atributos, los volvemos a enviar en el permalink como attributes[...]
    try {
      const attrs = cart && cart.attributes;
      if (attrs && typeof attrs === 'object') {
        Object.entries(attrs).forEach(([k, v]) => {
          if (v === undefined || v === null) return;
          const vv = String(v);
          if (vv.trim() === '') return;
          url.searchParams.set(`attributes[${k}]`, vv);
        });
      }
    } catch (e) { }

    url.searchParams.set('_ts', Date.now().toString());
    return url.toString();
  }

  function getDeliveryType() {
    try { return localStorage.getItem(LS_DELIVERY); } catch (e) { return null; }
  }
  function clearDeliveryType() {
    try { localStorage.removeItem(LS_DELIVERY); } catch (e) { }
  }

  function getSelectedPickupStore() {
    const checked = document.querySelector('input[name="pickup_location"]:checked');
    return checked ? checked.value : '';
  }

  form.addEventListener('submit', async (e) => {
    const submitter = e.submitter || document.activeElement;
    if (!submitter || submitter.name !== 'checkout') return;

    e.preventDefault();

    const type = getDeliveryType();
    // if (type !== 'shipping' && type !== 'pickup') {
    //     alert('Selecciona “Envío a domicilio” o “Recojo en tienda” antes de pagar.');
    //     return;
    // }
    // =========================
    // PICKUP FLOW
    // =========================
    if (type === 'pickup') {
      const storeName = getSelectedPickupStore(); // "Almacén Lince" (por defecto)
      if (!storeName) {
        alert('Selecciona la tienda de retiro antes de pagar.');
        return;
      }

      await updateCart({
        attributes: {
          "Tipo de entrega": "Retiro en tienda",
          "Tienda de retiro": storeName
        },
        note: `Tipo de entrega: Retiro en tienda | Tienda: ${storeName}`
      });

      // No podemos auto-marcar "Retiro en tienda" en checkout desde theme code.
      // Pero dejamos la instrucción clara:
      //   alert('En el checkout, selecciona “Retiro en tienda”. Tu tienda ya quedó registrada como: ' + storeName);

      window.location.href = '/checkout?_ts=' + Date.now();
      return;
    }

    // =========================
    // SHIPPING FLOW (UBIGEO)
    // =========================
    if (!$dep || !$prov || !$dist) {
      alert('No encuentro los selects de ubigeo en el carrito.');
      return;
    }

    const deptName = selectedText($dep);
    const provName = selectedText($prov);
    const distName = selectedText($dist);

    if (!deptName || !provName || !distName) {
      alert('Completa Departamento, Provincia y Distrito antes de pagar.');
      return;
    }

    const deptCode = DEPT_CODE[deptName] || '';

    const savedUbigeo = loadUbigeo() || {};
    const ltBeforeMin = savedUbigeo.lt_before_min;
    const ltBeforeMax = savedUbigeo.lt_before_max;
    const ltAfterMin = savedUbigeo.lt_after_min;
    const ltAfterMax = savedUbigeo.lt_after_max;
    const ubgDeptoId = savedUbigeo.deptoId;
    const ubgProvId = savedUbigeo.provId;
    const ubgDistId = savedUbigeo.distId;

    await updateCart({
      attributes: {
        "Tipo de entrega": "Despacho a domicilio",
        "Departamento": deptName,
        "Provincia": provName,
        "Distrito": distName,
        "_departamento_code": deptCode,
        "_ubigeo_depto_id": ubgDeptoId || "",
        "_ubigeo_prov_id": ubgProvId || "",
        "_ubigeo_dist_id": ubgDistId || "",
        "_lt_before_min": (ltBeforeMin ?? ""),
        "_lt_before_max": (ltBeforeMax ?? ""),
        "_lt_after_min": (ltAfterMin ?? ""),
        "_lt_after_max": (ltAfterMax ?? "")
      }
    });

    const cart = await getCart();

    const redirectUrl = buildPermalink(cart, {
      "checkout[shipping_address][country_code]": "PE",
      "checkout[shipping_address][province_code]": deptCode,
      "checkout[shipping_address][province]": deptName,
      "checkout[shipping_address][city]": provName,
      "checkout[shipping_address][address2]": distName
    });

    const storedCoupon = (localStorage.getItem('dawn_discount_code') || '').trim();
    if (storedCoupon) {
      const u = new URL(redirectUrl);
      u.searchParams.set('discount', storedCoupon);
      window.location.href = u.toString();
      return;
    }
    window.location.href = redirectUrl;

  }, true);
})();


/* =========================
   Custom Select UI (Ubigeo)
   - No rompe tu cascada actual
   - Se auto-actualiza cuando cambian los <option> (MutationObserver)
========================= */
(() => {
  const isCartPage = () => location.pathname === '/cart' || location.pathname.startsWith('/cart');

  function closeAll(exceptWrap = null) {
    document.querySelectorAll('#CartUbigeo .ubg-custom-select.is-open').forEach(wrap => {
      if (wrap !== exceptWrap) {
        wrap.classList.remove('is-open');
        const btn = wrap.querySelector('.ubg-select-display');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function initCustomSelect(selectEl) {
    if (!selectEl || selectEl.dataset.ubgCustom === '1') return;
    selectEl.dataset.ubgCustom = '1';

    // Creamos wrapper
    const wrap = document.createElement('div');
    wrap.className = 'ubg-custom-select';

    // Insertar wrapper antes del select
    selectEl.parentNode.insertBefore(wrap, selectEl);

    // Mover select dentro y ocultarlo visualmente
    selectEl.classList.add('ubg-native-select');
    wrap.appendChild(selectEl);

    // Botón visible
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ubg-select-display';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    wrap.appendChild(btn);

    // Lista
    const list = document.createElement('div');
    list.className = 'ubg-select-options';
    list.setAttribute('role', 'listbox');
    wrap.appendChild(list);

    function syncDisabled() {
      const disabled = !!selectEl.disabled;
      wrap.classList.toggle('is-disabled', disabled);
      btn.disabled = disabled;
      btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      if (disabled) {
        wrap.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }
    }

    function render() {
      // Texto seleccionado / placeholder
      const opts = Array.from(selectEl.options || []);
      const placeholder = opts[0]?.textContent || 'Selecciona...';
      const selectedOpt = selectEl.selectedOptions?.[0] || opts[0];

      const hasValue = !!selectEl.value;
      btn.textContent = (hasValue ? selectedOpt?.textContent : placeholder) || placeholder;
      btn.classList.toggle('is-placeholder', !hasValue);

      // Opciones
      list.innerHTML = '';
      opts.forEach((opt, idx) => {
        if (idx === 0) return; // saltar placeholder

        const item = document.createElement('div');
        item.className = 'ubg-select-option';
        item.textContent = opt.textContent;
        item.dataset.value = opt.value;

        if (opt.value === selectEl.value) item.classList.add('is-selected');

        item.addEventListener('click', () => {
          selectEl.value = opt.value;
          // Disparar change para que tu cascada funcione
          selectEl.dispatchEvent(new Event('change', { bubbles: true }));

          wrap.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        });

        list.appendChild(item);
      });

      syncDisabled();
    }

    // Abrir/cerrar
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      if (btn.disabled) return;

      const willOpen = !wrap.classList.contains('is-open');
      closeAll(wrap);

      wrap.classList.toggle('is-open', willOpen);
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });

    // Teclado básico
    btn.addEventListener('keydown', (e) => {
      if (btn.disabled) return;
      if (e.key === 'Escape') {
        wrap.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        btn.click();
      }
    });

    // Cerrar al click afuera
    document.addEventListener('click', () => closeAll(null));

    // Si tu JS cambia options/disabled, esto lo detecta y re-renderiza
    const obs = new MutationObserver(() => render());
    obs.observe(selectEl, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled']
    });

    // Si cambia el select por JS, re-render
    selectEl.addEventListener('change', () => render());

    // Si haces click en el label, abrimos el custom
    try {
      const field = selectEl.closest('.cart-ubigeo__field');
      const label = field?.querySelector(`label[for="${selectEl.id}"]`);
      if (label) {
        label.addEventListener('click', (ev) => {
          ev.preventDefault();
          if (!btn.disabled) btn.click();
        });
      }
    } catch (e) { }

    // Inicial
    render();
  }

  // Exponer para re-renders (cambios de qty, add/remove, etc.)
  window.CartUbigeo = window.CartUbigeo || {};
  window.CartUbigeo.initCustomSelects = () => {
    if (!isCartPage()) return;
    document.querySelectorAll('#CartUbigeo select.cart-ubigeo__select').forEach(initCustomSelect);
  };

  document.addEventListener('DOMContentLoaded', () => {
    window.CartUbigeo.initCustomSelects();
  });
})();


/* =========================
   Shipping rate estimate (Cart) — SOLO ENVÍO
   - Usa /cart/prepare_shipping_rates.json + /cart/async_shipping_rates.json
   - Muestra tarifa más barata según tu selección
   - ✅ Si es gratis => S/ 0.00
   - ✅ container-envio NO aparece hasta que haya dirección
========================= */
(() => {
  // Mapeo depto -> province_code (mismo que usas en el submit)
  const DEPT_CODE = {
    "Amazonas": "PE-AMA",
    "Áncash": "PE-ANC", "Ancash": "PE-ANC",
    "Apurímac": "PE-APU", "Apurimac": "PE-APU",
    "Arequipa": "PE-ARE",
    "Ayacucho": "PE-AYA",
    "Cajamarca": "PE-CAJ",
    "Cusco": "PE-CUS", "Cuzco": "PE-CUS",
    "Huancavelica": "PE-HUV",
    "Huánuco": "PE-HUC", "Huanuco": "PE-HUC",
    "Ica": "PE-ICA",
    "Junín": "PE-JUN", "Junin": "PE-JUN",
    "La Libertad": "PE-LAL",
    "Lambayeque": "PE-LAM",
    "Lima (Metropolitana)": "PE-LMA",
    "Lima (Departamento)": "PE-LIM",
    "Loreto": "PE-LOR",
    "Madre de Dios": "PE-MDD",
    "Moquegua": "PE-MOQ",
    "Pasco": "PE-PAS",
    "Piura": "PE-PIU",
    "Puno": "PE-PUN",
    "San Martín": "PE-SAM", "San Martin": "PE-SAM",
    "Tacna": "PE-TAC",
    "Tumbes": "PE-TUM",
    "Ucayali": "PE-UCA"
  };

  // Shopify canónico para rates (según tu checkout)
  function provinceNameForRates(deptName, deptCode) {
    if (deptCode === 'PE-LMA') return 'Lima (provincia)';
    if (deptCode === 'PE-LIM') return 'Lima (departamento)';
    return deptName;
  }

  const sleep = (ms) => new Promise(r => setTimeout(r, ms));


  /* =========================
     PROMO HARD-CODE (Shipping Discounts)
     Regla:
       - Cart contains: al menos 1 producto de las colecciones (handles):
         - combos-multimarca
         - qcy
       - Y Cart quantity (cart.item_count) <= 4
     ========================= */
  const PROMO_FREE_SHIPPING = {
    enabled: true,
    max_qty: 4,
    discount_value: 9.9, // Fixed amount off (en moneda del carrito)
    collection_handles: ['duos', 'productos-qcy'],
    cache_ttl_ms: 6 * 60 * 60 * 1000, // 6h
    max_pages: 20,
  };

  const DEBUG_PROMO_SHIP = true;
  function dbgP(...args) {
    if (!DEBUG_PROMO_SHIP) return;
    try { console.log('%c[PROMO_SHIP]', 'color:#10b981;font-weight:700', ...args); } catch (e) { }
  }

  const __promo = { idsSet: null, idsTs: 0, inflight: null, cart: null, cartTs: 0 };

  function readLsJson(key) {
    try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { return null; }
  }
  function writeLsJson(key, val) {
    try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) { }
  }

  async function fetchCartForPromo() {
    const now = Date.now();
    // cache corto para no spamear /cart.js
    if (__promo.cart && (now - __promo.cartTs) < 1200) return __promo.cart;
    const r = await fetch('/cart.js?ts=' + now, { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
    const cart = await r.json().catch(() => null);
    __promo.cart = cart;
    __promo.cartTs = now;
    return cart;
  }

  async function fetchCollectionProductIds(handle) {
    const ids = new Set();
    for (let page = 1; page <= PROMO_FREE_SHIPPING.max_pages; page++) {
      const url = `/collections/${handle}/products.json?limit=250&page=${page}`;
      const r = await fetch(url, { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
      if (!r.ok) {
        dbgP('colección no accesible', { handle, status: r.status, url });
        break;
      }
      const data = await r.json().catch(() => ({}));
      const products = Array.isArray(data?.products) ? data.products : [];
      for (const p of products) if (p && typeof p.id === 'number') ids.add(p.id);

      // si ya no hay más, cortamos
      if (products.length < 250) break;
    }
    return Array.from(ids);
  }

  async function getPromoIdsSet() {
    if (!PROMO_FREE_SHIPPING.enabled) return new Set();

    const now = Date.now();
    if (__promo.idsSet && (now - __promo.idsTs) < PROMO_FREE_SHIPPING.cache_ttl_ms) return __promo.idsSet;
    if (__promo.inflight) return __promo.inflight;

    __promo.inflight = (async () => {
      const finalSet = new Set();

      for (const handle of PROMO_FREE_SHIPPING.collection_handles) {
        const lsKey = `__promo_col_ids_v2_${handle}`;
        const cached = readLsJson(lsKey);

        if (cached && cached.ts && Array.isArray(cached.ids) && (now - cached.ts) < PROMO_FREE_SHIPPING.cache_ttl_ms) {
          cached.ids.forEach((id) => finalSet.add(Number(id)));
          continue;
        }

        try {
          const ids = await fetchCollectionProductIds(handle);
          ids.forEach((id) => finalSet.add(Number(id)));
          writeLsJson(lsKey, { ts: now, ids });
        } catch (e) {
          dbgP('error leyendo colección', handle, e);
        }
      }

      __promo.idsSet = finalSet;
      __promo.idsTs = now;
      __promo.inflight = null;

      dbgP('ids cargados', { total: finalSet.size, handles: PROMO_FREE_SHIPPING.collection_handles });
      return finalSet;
    })();

    return __promo.inflight;
  }

  async function promoFreeShippingApplies() {
    if (!PROMO_FREE_SHIPPING.enabled) return { applies: false, reason: 'disabled' };

    const cart = await fetchCartForPromo();
    if (!cart || !Array.isArray(cart.items)) return { applies: false, reason: 'no-cart' };

    const qty = Number(cart.item_count || 0);
    if (!(qty <= PROMO_FREE_SHIPPING.max_qty)) return { applies: false, reason: 'qty', qty };

    const idsSet = await getPromoIdsSet();
    if (!idsSet || !idsSet.size) return { applies: false, reason: 'no-ids', qty };

    const matchItem = cart.items.find((it) => idsSet.has(Number(it.product_id)));
    return { applies: !!matchItem, reason: matchItem ? 'match' : 'no-match', qty, product_id: matchItem?.product_id };
  }

  const LS_DELIVERY = 'cart_delivery_type_v1'; // 'shipping' | 'pickup'
  function getDeliveryType() {
    try { return localStorage.getItem(LS_DELIVERY); } catch (e) { return null; }
  }
  function setDeliveryType(type) {
    try { localStorage.setItem(LS_DELIVERY, type); } catch (e) { }
  }
  function clearDeliveryType() {
    try { localStorage.removeItem(LS_DELIVERY); } catch (e) { }
  }
  function isPickup() {
    return getDeliveryType() === 'pickup';
  }

  function renderPickupFree() {
    const els = getEls();
    if (!els.box) return;

    // mostramos el bloque “Envío” pero en 0
    setContainerVisible(true);

    els.box.hidden = false;
    els.box.classList.remove('is-loading');

    if (els.price) els.price.textContent = formatMoneyAmount(0); // ✅ Envío gratis (S/ 0.00)
    if (els.msg) els.msg.textContent = '';

    // ✅ Total vuelve al base (que ya incluye cupones/descuentos)
    updateTotalWithShipping(0);
  }

  function getEls() {
    const box = document.getElementById('CartShippingEstimate');
    return {
      box,
      container: box ? box.closest('.container-envio') : null,
      price: document.getElementById('CartShippingEstimatePrice'),
      method: document.getElementById('CartShippingEstimateMethod'),
      addr: document.getElementById('CartShippingEstimateAddr'),
      msg: document.getElementById('CartShippingEstimateMsg'),
    };
  }

  function setContainerVisible(visible) {
    const els = getEls();
    if (!els.container) return;
    els.container.classList.toggle('is-visible', !!visible);
  }

  function selectedText(selectId) {
    const sel = document.getElementById(selectId);
    if (!sel) return '';
    return (sel.options[sel.selectedIndex]?.textContent || '').trim();
  }

  function formatMoneyAmount(amount) {
    const n = Number(amount || 0);
    const currency = (window.Shopify?.currency?.active) || 'PEN';
    try {
      return new Intl.NumberFormat('es-PE', { style: 'currency', currency }).format(n);
    } catch (e) {
      return `${currency} ${n.toFixed(2)}`;
    }
  }

  function formatMoneyFromCents(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      const fmt = Shopify.money_with_currency_format || Shopify.money_format;
      return Shopify.formatMoney(cents, fmt);
    }
    const currency = (window.Shopify?.currency?.active) || 'PEN';
    return new Intl.NumberFormat('es-PE', { style: 'currency', currency }).format((cents || 0) / 100);
  }

  function updateTotalWithShipping(shippingCents) {
    const els = getEls();
    const footer = els.box?.closest('#main-cart-footer') || document.getElementById('main-cart-footer');
    const totalEl = footer?.querySelector('[data-cart-total-value]');
    if (!totalEl) return;

    const baseCents = Number(totalEl.dataset.baseCents || 0);
    const shipCents = Number(shippingCents || 0);

    totalEl.textContent = formatMoneyFromCents(baseCents + shipCents);
  }

  function renderHidden() {
    const els = getEls();
    if (!els.box) return;
    els.box.hidden = true;
    els.box.classList.remove('is-loading');
    setContainerVisible(false);

    // ✅ total vuelve al base (sin envío estimado)
    updateTotalWithShipping(0);
  }

  function renderLoading(text = 'Calculando envío…') {
    const els = getEls();
    if (!els.box) return;

    // ✅ ya hay dirección => mostramos container
    setContainerVisible(true);

    els.box.hidden = false;
    els.box.classList.add('is-loading');

    if (els.price) els.price.textContent = '...';
    if (els.method) els.method.textContent = '';
    if (els.addr) els.addr.textContent = '';
    if (els.msg) els.msg.textContent = text;
  }

  function renderNoRates(addrText) {
    const els = getEls();
    if (!els.box) return;

    setContainerVisible(true);

    els.box.hidden = false;
    els.box.classList.remove('is-loading');

    if (els.price) els.price.textContent = '—';
    if (els.method) els.method.textContent = '';
    if (els.addr) els.addr.textContent = addrText || '';
    if (els.msg) els.msg.textContent = 'No hay tarifas disponibles para esta zona (se confirmará en checkout).';

    // ✅ total base (sin envío)
    updateTotalWithShipping(0);
  }

  function renderRate(bestRate, addrText) {
    const els = getEls();
    if (!els.box) return;

    setContainerVisible(true);

    els.box.hidden = false;
    els.box.classList.remove('is-loading');

    const priceNum = Number(bestRate?.price || 0);      // ej: 20.00
    const shipCents = Math.round(priceNum * 100);       // ✅ a centavos

    const priceText = formatMoneyAmount((priceNum <= 0) ? 0 : priceNum); // ✅ 0 => S/ 0.00

    if (els.price) els.price.textContent = priceText;
    if (els.method) els.method.textContent = bestRate?.name ? bestRate.name : 'Envío';
    if (els.addr) els.addr.textContent = addrText || '';
    if (els.msg) els.msg.textContent = '';

    // ✅ Total = carrito (centavos) + envío estimado (centavos)
    updateTotalWithShipping(shipCents);
  }

  function buildAddressFromSelection() {
    const selDepto = document.getElementById('ubigeo-depto');
    const selProv = document.getElementById('ubigeo-prov');
    const selDist = document.getElementById('ubigeo-dist');

    if (!selDepto || !selProv || !selDist) return null;

    const deptoVal = String(selDepto.value || '').trim();
    const provVal = String(selProv.value || '').trim();
    const distVal = String(selDist.value || '').trim();

    // ✅ Si aún hay placeholders (value="") o selects deshabilitados => NO hay dirección
    if (!deptoVal || !provVal || !distVal) return null;
    if (selProv.disabled || selDist.disabled) return null;

    const deptoName = (selDepto.options[selDepto.selectedIndex]?.textContent || '').trim();
    const provName = (selProv.options[selProv.selectedIndex]?.textContent || '').trim();
    const distName = (selDist.options[selDist.selectedIndex]?.textContent || '').trim();

    const deptCode = DEPT_CODE[deptoName] || '';
    const provinceForRates = provinceNameForRates(deptoName, deptCode);

    // ✅ ESTE es el formato que Shopify espera para shipping rates
    return {
      country: 'Peru',
      country_code: 'PE',
      province: provinceForRates,
      province_code: deptCode,
      city: provName,
      address1: '',
      address2: distName,
      zip: ''
    };
  }

  async function prepareShippingRates(address) {
    const r = await fetch('/cart/prepare_shipping_rates.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ shipping_address: address })
    });

    if (!r.ok) {
      let payload = null;
      try { payload = await r.json(); } catch (e) { payload = await r.text(); }
      console.warn('[prepare_shipping_rates]', r.status, payload, address);
      throw new Error('No se pudo preparar tarifas de envío');
    }
  }

  async function pollShippingRates(maxTries = 12) {
    for (let i = 0; i < maxTries; i++) {
      const r = await fetch('/cart/async_shipping_rates.json', {
        headers: { 'Accept': 'application/json' },
        cache: 'no-store'
      });

      const data = await r.json().catch(() => ({}));
      if (data && Array.isArray(data.shipping_rates)) return data.shipping_rates;

      await sleep(350);
    }
    return [];
  }

  async function getRates(address) {
    await prepareShippingRates(address);
    return await pollShippingRates();
  }

  // Debounce para no spamear requests
  let t = null;
  let lastKey = '';
  let inflight = false;

  async function updateEstimate(force = false) {
    const els = getEls();
    if (!els.box) return;

    // ✅ Si aún no eligieron tipo de entrega, no mostramos envío ni tocamos el total
    const type = getDeliveryType();
    if (type !== 'shipping' && type !== 'pickup') {
      renderHidden();
      return;
    }

    // ✅ si es recojo en tienda => envío gratis (0)
    if (type === 'pickup') {
      renderPickupFree();
      return;
    }

    const address = buildAddressFromSelection();
    if (!address) {
      renderHidden(); // ✅ en vez de renderNoSelection()
      return;
    }

    const provLabel = selectedText('ubigeo-prov');
    const distLabel = selectedText('ubigeo-dist');
    const addrText = `${distLabel}, ${provLabel}`;

    const key = JSON.stringify({
      province: address.province_code || address.province,
      city: address.city,
      dist: address.address2
    });

    if (!force && inflight) return;
    if (!force && key === lastKey) return;

    lastKey = key;
    inflight = true;
    renderLoading('Calculando envío…');

    try {
      // ✅ Promo (hard-code): Shipping Discounts => descuento fijo en el envío
      // Regla app: si aplica, mostramos la tarifa más barata MENOS discount_value (mínimo 0)
      try {
        const promo = await promoFreeShippingApplies();
        dbgP('check', promo);

        if (promo.applies) {
          const disc = Number(PROMO_FREE_SHIPPING.discount_value || 0);
          const discCents = Math.max(0, Math.round(disc * 100));

          // Para descontar necesitamos conocer la tarifa base (rates).
          const ratesPromo = await getRates(address);

          if (!ratesPromo || !ratesPromo.length) {
            // Si Shopify no devuelve rates, no podemos calcular el descuento aquí.
            renderNoRates(addrText);
            return;
          }

          const bestBase = ratesPromo
            .slice()
            .sort((a, b) => Number(a.price || 0) - Number(b.price || 0))[0];

          const basePriceNum = Number(bestBase?.price || 0);
          const baseCents = Math.round(basePriceNum * 100);

          const finalCents = Math.max(0, baseCents - discCents);
          const finalPriceNum = finalCents / 100;

          renderRate({ name: bestBase?.name ? bestBase.name : 'Envío', price: finalPriceNum }, addrText);

          // Mensaje de descuento (opcional)
          const _els = getEls();
          if (_els.msg && discCents > 0) {
            _els.msg.textContent = `Descuento de envío aplicado: -${formatMoneyFromCents(discCents)}`;
          }
          return;
        }
      } catch (e) {
        dbgP('error evaluando promo', e);
      }

      const rates = await getRates(address);

      if (!rates || !rates.length) {
        renderNoRates(addrText);
        return;
      }

      const best = rates
        .slice()
        .sort((a, b) => Number(a.price || 0) - Number(b.price || 0))[0];

      renderRate(best, addrText);
    } catch (e) {
      renderNoRates(addrText);
    } finally {
      inflight = false;
    }
  }

  function schedule(force = false) {
    clearTimeout(t);
    t = setTimeout(() => updateEstimate(force), 250);
  }

  // Cambios en selects
  document.addEventListener('change', (e) => {
    const id = e.target?.id;
    if (id === 'ubigeo-depto' || id === 'ubigeo-prov' || id === 'ubigeo-dist') {
      schedule(true);
    }
  });

  document.addEventListener('DOMContentLoaded', () => schedule(true));
  window.addEventListener('pageshow', () => schedule(true));

  // Exponer refresh global + escuchar re-renders del carrito
  window.CartShippingEstimate = window.CartShippingEstimate || {};
  window.CartShippingEstimate.refresh = (force = false) => schedule(!!force);
  let __lastForcedRender = 0;
  document.addEventListener('cart:rendered', (ev) => {
    const now = Date.now();
    const source = ev?.detail?.source || '';
    const els = getEls();

    // ✅ Si el carrito se re-renderiza por cupón/descuentos, el bloque de envío suele resetearse (hidden).
    // Forzamos 1 refresh (throttled) para volver a pintarlo.
    const shouldForce = (source === 'discount') || (els.box && els.box.hidden);

    if (shouldForce && (now - __lastForcedRender) > 800) {
      __lastForcedRender = now;
      schedule(true);
    } else {
      schedule(false);
    }
  });
})();


(() => {
  if (!location.pathname.startsWith('/cart')) return;

  const isCartMutationUrl = (url = '') => {
    const u = String(url);
    return (
      /\/cart\/(add|change|update|clear)\.js(\?|$)/.test(u) ||
      // algunos themes recalculan secciones con endpoints tipo ?sections=...
      (u.includes('sections=') && u.includes('/cart'))
    );
  };

  const debounce = (fn, wait = 250) => {
    let t = null;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  const refresh = debounce(async () => {
    // 1) Traer cart actualizado (para item_count + total_price)
    let cart = null;
    try {
      const r = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' },
        cache: 'no-store',
        credentials: 'same-origin'
      });
      cart = await r.json();
    } catch (e) { }

    // 2) Actualizar contador del resumen “Entregar X ítems” (DOM fresco)
    try {
      const summary = document.getElementById('CartUbigeoSummary');
      if (summary && !summary.hidden && cart) {
        const sumItems = summary.querySelector('[data-ubigeo-items]');
        const count = Number(cart.item_count || 0);
        const itemsText = count === 1 ? '1 ítem' : `${count} ítems`;
        if (sumItems) sumItems.textContent = itemsText;
      }
    } catch (e) { }
    // ✅ refrescar ETA (si está configurado)
    try { window.CartUbigeo?.refreshEta?.(); } catch (e) { }

    // 3) Actualizar base cents del Total (para que tu “Total + envío” sume bien)
    try {
      const totalEl = document.querySelector('[data-cart-total-value]');
      if (totalEl && cart) totalEl.dataset.baseCents = String(cart.total_price || 0);
    } catch (e) { }

    // 4) Recalcular envío (y que vuelva a mostrarse sin recargar)
    try {
      window.CartShippingEstimate?.refresh?.(false);
    } catch (e) { }
  }, 300);

  // Eventos custom (por si el theme los emite)
  ['cart:rendered', 'cart:updated', 'cart:change'].forEach((evt) => {
    document.addEventListener(evt, refresh);
  });

  // ✅ Hook FETCH
  if (!window.__CART_FETCH_HOOKED__) {
    window.__CART_FETCH_HOOKED__ = true;
    const _fetch = window.fetch;
    window.fetch = async (...args) => {
      const res = await _fetch(...args);
      try {
        const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
        if (isCartMutationUrl(url)) setTimeout(refresh, 0);
      } catch (e) { }
      return res;
    };
  }

  // ✅ Hook XHR (muchos themes usan esto)
  if (!window.__CART_XHR_HOOKED__) {
    window.__CART_XHR_HOOKED__ = true;

    const open = XMLHttpRequest.prototype.open;
    const send = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this.__cartUrl = url;
      return open.call(this, method, url, ...rest);
    };

    XMLHttpRequest.prototype.send = function (...args) {
      this.addEventListener('loadend', () => {
        try {
          if (isCartMutationUrl(this.__cartUrl)) setTimeout(refresh, 0);
        } catch (e) { }
      });
      return send.apply(this, args);
    };
  }

  // ✅ Fallback: MutationObserver (si el theme no usa fetch ni XHR detectable)
  const moTarget =
    document.querySelector('cart-items') ||
    document.getElementById('main-cart-items');

  if (moTarget && !moTarget.__cartMoAttached) {
    moTarget.__cartMoAttached = true;
    const mo = new MutationObserver(() => refresh());
    mo.observe(moTarget, { childList: true, subtree: true });
  }

  // Primer refresh
  refresh();
})();